import { prependRoot } from "../util/prependRoot.js";
import { getApiRoot } from "../store/configureStore.js";
import axios from "axios";

const routePrefix = "/federatie/";

const FederatieApi = {
	getOpenAanvragenByFederatie(federatieId) {
		const serviceUrl = prependRoot(routePrefix + 'getopenaanvragenbyfederatie/' + federatieId, getApiRoot());
		return axios.get(serviceUrl, {
			headers: { accept: "application/json" }
		});
	},
	getSportclubsByFederatieByFilter(federatieId, filter) {
		const serviceUrl = prependRoot(routePrefix + 'getsportclubsbyfederatiebyfilter/' + federatieId, getApiRoot());
		return axios.post(serviceUrl, filter, {
			headers: {
				'accept': 'application/json'
			}
		});
	},
	createExportRequestForSportclubs(request) {
		const serviceUrl = prependRoot(routePrefix + 'createExportRequestSportclubs', getApiRoot());
		return axios.put(serviceUrl,
			request, {
			headers: {
				accept: "application/json"
			}
		});
	},
	requestUnlinkSportclub(federatieId, sportclubId) {
		const serviceUrl = prependRoot(routePrefix + 'requestUnlinkSportclub/' + federatieId + '/' + sportclubId, getApiRoot());
		return axios.put(serviceUrl,
			{
				headers: {
					accept: "application/json"
				}
			});
	},
	requestLinkSportclub(federatieId, sportclubId) {
		const serviceUrl = prependRoot(routePrefix + 'requestLinkSportclub/' + federatieId + '/' + sportclubId, getApiRoot());
		return axios.put(serviceUrl,
			{
				headers: {
					accept: "application/json"
				}
			});
	}
};

export default FederatieApi;
